import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import Planmodal from "../Plan_modal";
import { useShareOption } from "../../hooks/share/useShareOption";

const ShareOption = ({
  mybusinessType,
  handleCloseshare,
  showshare,
  sharetoOthers,
  originShopId,
  timelineid,
  postId,
  id,
  refetchTimeline,
  onShareSuccess,
}) => {
  const {
    checkboxes,
    isShareDisabled,
    isSharing,
    modalShow,
    setModalShow,
    listsharetoother,
    isInvalidData,
    handleSelectAll,
    handleSelectSingle,
    handleShare,
    sendFallbackTimeline,
  } = useShareOption({
    mybusinessType,
    sharetoOthers,
    originShopId,
    timelineid,
    postId,
    id,
    handleCloseshare,
    refetchTimeline,
    onShareSuccess,
  });

  return (
    <>
      <Planmodal show={modalShow} setModalShow={setModalShow} />

      <Modal show={showshare} onHide={handleCloseshare} animation={false}>
        <Modal.Header closeButton>
          <h6>Share on</h6>
        </Modal.Header>

        <Modal.Body>
          <Row className="d-flex align-items-center">
            {/* LEFT → BT Button (marketer only) */}
            {(window.location.pathname === "/marketing-profile" ||
              (localStorage.getItem("MeAsmarketerId") &&
                localStorage.getItem("MeAsmarketerId") !== "undefined" &&
                localStorage.getItem("MeAsmarketerId") !== "null" &&
                (localStorage.getItem("previousRoute") === "marketing-clients" ||
                  localStorage.getItem("previousRoute") === "marketing-profile"))) && (
              <>
                <Col>
                  <Button size="sm" onClick={sendFallbackTimeline}>
                    Show BT to share with
                  </Button>
                </Col>
              </>
            )}

            {/* RIGHT → Select All */}
            <Col className="d-flex justify-content-end">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="selectAllCheckbox"
                  checked={
                    isInvalidData
                      ? listsharetoother.length > 0 &&
                        listsharetoother.every((item) => item.isSelected)
                      : checkboxes.length > 0 &&
                        checkboxes.every((item) => item.isSelected)
                  }
                  onChange={handleSelectAll}
                />
                <label
                  className="form-check-label font_11"
                  htmlFor="selectAllCheckbox"
                >
                  Select all
                </label>
              </div>
            </Col>
          </Row>

          <Row>
            {isInvalidData ? (
              listsharetoother?.map((item) => (
                <Col lg="6" key={item.id}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={item.id}
                      id={`checkbox-${item.id}`}
                      checked={item.isSelected}
                      onChange={handleSelectSingle}
                    />
                    <label
                      className="form-check-label font_11"
                      htmlFor={`checkbox-${item.id}`}
                    >
                      {item.label}
                    </label>
                  </div>
                </Col>
              ))
            ) : (
              checkboxes.map((checkbox) => (
                <Col lg="6" key={checkbox.id}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={checkbox.id}
                      id={`checkbox-${checkbox.id}`}
                      checked={checkbox.isSelected}
                      onChange={handleSelectSingle}
                    />
                    <label
                      className="form-check-label font_11"
                      htmlFor={`checkbox-${checkbox.id}`}
                    >
                      {checkbox.label}
                    </label>
                  </div>
                </Col>
              ))
            )}
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="btn btn-primary"
            onClick={handleShare}
            disabled={isShareDisabled || isSharing}
          >
            {isSharing ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Sharing...
              </>
            ) : (
              "Share"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ShareOption;
